import { isNonNullable } from '../helpers'
import { EnhancedGuideInformation, GuideInformation } from '../types'
import { getAllFilesForVersion } from './get-all-files-for-version'

export function mapVersionPages(guide: GuideInformation): EnhancedGuideInformation {
	if (guide.guideConfig.variant === 'API_REFERENCE') {
		return {
			...guide,
			versionInformation: guide.versionInformation
				.map((version) => {
					if (!version.config) {
						return null
					}
					return {
						...version,
						allPagePaths: [],
					}
				})
				.filter(isNonNullable),
		}
	}

	return {
		...guide,
		versionInformation: guide.versionInformation.map((version) => {
			const config = version.config

			if (!config || !('sidebar' in config)) {
				return {
					...version,
					allPagePaths: [],
				}
			}

			return {
				...version,
				allPagePaths: getAllFilesForVersion(version.versionFolderPath).mdxFilePathsInVersionFolder,
			}
		}),
	}
}

export function getSidebarFilePathsWithFullSlug() {}
